export function ProgressBar({
  step,
  total,
  className = '',
}: {
  step: number
  total: number
  className?: string
}) {
  return (
    <div className={`flex shrink-0 items-center gap-2 overflow-hidden px-4 py-2 ${className}`}>
      <p className="m-0 flex items-center gap-0.5 whitespace-nowrap">
        <span className="text-body-md font-semibold text-violet-500">
          {String(step).padStart(2, '0')}
        </span>
        <span className="text-body-sm text-white-900">{` / ${String(total).padStart(2, '0')}`}</span>
      </p>
      <span className="flex min-w-0 flex-1 shrink-0 grow basis-0 items-center gap-1 overflow-hidden">
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            className={
              i < step
                ? 'h-1 min-w-0 flex-1 shrink-0 grow basis-0 rounded-sm bg-violet-500'
                : 'h-1 min-w-0 flex-1 shrink-0 grow basis-0 rounded-sm bg-white-200'
            }
          />
        ))}
      </span>
    </div>
  )
}
